import * as React from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Audio from "../../../ui-components/Audio";

export default function MultipleChoiceColumn({
	question,
	onAnswer = () => {},
}) {
	const theme = useTheme();
	const questions = question.questionList || [];
	const [answer, setAnswer] = React.useState(
		Array(questions.length).fill("")
	);

	React.useEffect(() => {
		setAnswer(Array(questions.length).fill(""));
	}, [question, questions.length]);

	const handleSetAnswer = (choice, i) => {
		let ans = [...answer];
		ans[i] = choice;
		setAnswer(ans);

		const canProceed =
			ans.filter((a) => a !== "").length === questions.length;
		const formattedAnswer = questions.reduce((acc, q, index) => {
			const key = Object.keys(question.answer.value)[index];
			acc[key] = ans[index] || "";
			return acc;
		}, {});

		onAnswer({
			canProceed,
			answer: formattedAnswer,
		});
	};

	return (
		<React.Fragment>
			{question.questionImage && (
				<Box
					sx={{
						width: "100%",
						background: "white",
						pb: 2,
						pt: 1,
						px: 1,
					}}
					className="image-container"
				>
					<img
						src={question.questionImage}
						alt="Question"
						style={{ width: "100%" }}
					/>
				</Box>
			)}

			{question.questionAudio && (
				<Audio audioText={question.questionAudio} />
			)}

			<Box className="choices-container">
				{questions.map((q, i) => (
					<Box sx={{ mt: 3 }} key={`question-${i}`}>
						<Grid container justifyContent="center">
							<Typography
								variant="h1"
								sx={{
									textAlign: "center",
									color: theme.palette.primary.dark,
									fontSize: 20,
								}}
							>
								{q.text}
							</Typography>
						</Grid>
						<Grid
							container
							gap={1}
							justifyContent="center"
							sx={{ mt: 1 }}
						>
							{q.choices.map((choice, j) => (
								<Grid
									item
									sm={5}
									xs={12}
									key={`choices-${i}-${j}`}
								>
									<Button
										variant={
											answer[i] ===
											(choice?.value || choice)
												? "contained"
												: "outlined"
										}
										fullWidth
										size="large"
										sx={{
											fontSize: "1.2rem",
											px: 1,
											lineHeight: "1.2em",
										}}
										onClick={() =>
											handleSetAnswer(
												choice?.value || choice,
												i
											)
										}
									>
										{choice?.label || choice}
									</Button>
								</Grid>
							))}
						</Grid>
					</Box>
				))}
			</Box>
		</React.Fragment>
	);
}
